module.exports = __webpack_public_path__ + "img/car_1_mazda.dff6b325.jpg";